import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';

import { AuthService } from '../login/auth.service';
import {
  AddProductToCartDto,
  Cart,
  CreateCartDto,
  ProductInCart,
  ProductInWarehouse,
  RemoveProductFromCartDto,
  UpdateCartDto,
  UpdateProductInCartDto
} from 'src/typings';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  constructor(private http: HttpClient, private authService: AuthService, private socket: Socket) {}

  cartSocket = this.socket.fromEvent<Cart>('cart_updated');

  create(payload: CreateCartDto) {
    return this.http.post<Cart>(`${environment.BACKEND}/cart/create`, payload);
  }

  update(payload: UpdateCartDto) {
    return this.http.put<Cart>(`${environment.BACKEND}/cart/update`, payload);
  }

  delete(id: number) {
    return this.http.delete(`${environment.BACKEND}/cart/${id}`);
  }

  addProduct(payload: AddProductToCartDto) {
    return this.http.put<Cart>(`${environment.BACKEND}/cart/add_product`, payload);
  }

  removeProduct(payload: RemoveProductFromCartDto) {
    return this.http.put<Cart>(`${environment.BACKEND}/cart/remove_product`, payload);
  }

  updateProductInCart(payload: UpdateProductInCartDto) {
    return this.http.put<ProductInCart>(
      `${environment.BACKEND}/cart/update_product_in_cart`,
      payload
    );
  }

  clear(id: number) {
    return this.http.put<Cart>(`${environment.BACKEND}/cart/clear/${id}`, null);
  }

  getOne(id: number) {
    return this.http.get<Cart>(`${environment.BACKEND}/cart/${id}`).pipe(
      map((data: Cart) => {
        if (!data.products) return data;
        data.products = data.products.map((prod) => {
          return {
            ...prod,
            quan: Number(prod.quan),
            price: Number(prod.price),
            sum: Number(prod.sum),
            product: {
              ...prod.product,
              stock: prod.product.stock.map((wh: ProductInWarehouse) => {
                return { ...wh, quan: Number(wh.quan) };
              })
            }
          };
        });
        return data;
      })
    );
  }
}
